//Componentes generales
import React, { useState } from "react";

import moment from "moment";

//Permisos
import {EDITAR_REQUERIMIENTO, MODIFICAR_ESTADO_REQUERIMIENTO, VER_TODOS_REQUERIMIENTOS, REENVIO_YARAVI} from "../../utils/permisos";

//Tipos de Prioridades
import { PRIORITYOUT } from '../../utils/priority';
import Swal from "sweetalert2";
import useLoading from "../../customHooks/useLoading";

    const RenderRow = ({ item, currentUser,index, style, listTDoc, filter, checkPermisos, cambiarEstado, editar,  verDetalles, statesNEviables, sendToAPI, deleteTDoc}) => { 

        let currentLista = listTDoc;
        const {loading,setLoading} = useLoading(false);
        /*
        if(checkPermisos(VER_TODOS_REQUERIMIENTOS)){
            currentLista = listTDoc;
        }else{
            currentLista = listTDoc.filter(r => r.userName.includes(currentUser.userName));
        }*/

        const handleSendToAPI = async() => {
            setLoading(true);
            Swal.fire("Un aviso se mostrara al finalizar...");
            sendToAPI(item)
            .then((res) => {
                setLoading(false);
            })
            .catch((err) => {
                console.log("error en handleSendToApi RRReqs");
                console.log(err);
                setLoading(false);
            })
        }

        return <div style={style}>
            <div className='container-r-list-item'>
                <div className='container-r-list-item-header'>
                    <div className='r-list-item-header-clave'>{item.tDocCodFor + ' - ' + item.tDocNroFor}</div>
                    {item.codActivo && <div className='r-list-item-header-activo'>{item.codActivo}</div>}
                    <div className='r-list-item-header-title'>{item.title}</div>
                    <div className="margin-right-r">
                        <div className={item.priority === 0 ? 'r-list-item-header-priority-media' : item.priority === 1 ? 'r-list-item-header-priority-alta' : 'r-list-item-header-priority-urgente'}>{PRIORITYOUT[item.priority]}</div>
                    </div>
                </div>
                <div className='container-r-list-item-details'>
                    <div className={`r-list-item-details-clave`} style={{backgroundColor: (item.state == 'ENPROCESO') ? 'rgb(228, 148, 0)' : (item.state == 'FINALIZADA') && 'greenyellow', color: (item.state == 'ENPROCESO') && 'white'}}>{(item.state == 'ENPROCESO') ? 'EN PROCESO' : item.state}</div>
                    <div className='r-list-item-details-title'>Creada el: {moment(item.fecAlt).format('DD-MM-YYYY HH:MM')}</div>
                    {item.fechaCompletado && <div className='r-list-item-details-title'>
                        Fecha Completada: <label style={{color:'green', fontWeight:400}}>{moment(item.fechaCompletado).format('DD-MM-YYYY')}</label>
                    </div>}
                    <div className='r-list-item-details-title'>Usuario: {item.userName}</div>
                    <div className='r-list-item-details-title'>Fecha de Entrega Estimada: {moment(item.deliveryDate).format('DD-MM-YYYY')}</div>
                    <div className='r-list-item-details-title'>Ultima modificación: {moment(item.fecMod).format('DD-MM-YYYY')}</div>
                </div>
                <div className='container-r-list-item-btn'>
                    {(checkPermisos(MODIFICAR_ESTADO_REQUERIMIENTO) && item.state != 'FINALIZADA') &&
                        <div className='r-list-item-btn-A' onClick={() => cambiarEstado(item)}>Modificar Estado</div>
                    }
                    {(checkPermisos(EDITAR_REQUERIMIENTO) && item.state != 'FINALIZADA') &&
                        <div className='r-list-item-btn-A' onClick={() => editar(item.tDocNroFor)}>Editar</div>
                    }
                    {(checkPermisos(EDITAR_REQUERIMIENTO) && item.state != 'FINALIZADA') &&
                        <div className='r-list-item-btn-A' id="deleteODT" onClick={() => deleteTDoc(item.tDocNroFor, item._id, item.state)}>Eliminar</div>
                    }
                    <div className='r-list-item-btn-A' onClick={() => verDetalles(item)}>Detalles</div>
                </div>
                {!item.enviado && item.envioExterno && <div
                  className={`${"container-resend"}`}
                  onClick={() => !loading && handleSendToAPI()}
                >
                  {"Enviar ODT >>>"}
                </div>}
            </div>
        </div>
    };

export default RenderRow